import { c as _c } from "react/compiler-runtime";
import { APIDestination } from '../../../../../../../../typings/Destination.interface';
import Button from '../../../../common/base/Button';
import { StyledCardSection } from '../../../../common/base/Card';
import Text from '../../../../common/base/Text';
import Dropdown from '../../../../common/Dropdown';
import { Div } from '../../../../common/helpers/StyledUtils';
import { PreviewBucket } from '../../../../common/Histogram/PreviewHistogram';
import PreviewHistogram from '../../../../common/Histogram/PreviewHistogram';
type Props = {
  data_2h_sample: PreviewBucket[];
  data_4h_sample: PreviewBucket[];
  destination: APIDestination;
  ghost?: boolean;
};
const dimensions_config = {
  successful: {
    color: 'green_histogram',
    label: 'Successful'
  },
  failed: {
    color: 'red_histogram',
    label: 'Failed'
  }
} as const;
const DestinationMetricsPreview = t0 => {
  const $ = _c(18);
  const {
    data_2h_sample,
    data_4h_sample,
    destination,
    ghost
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      px: 72
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data_4h_sample || $[2] !== ghost) {
    t2 = (opened, toggle) => <Button outline={!ghost} ghost={ghost} active={opened} p={1.5} w={100} onClick={e_0 => {
      e_0.stopPropagation();
      toggle(!opened);
    }}><PreviewHistogram size="small" values={data_4h_sample} dimensions_config={dimensions_config} resolution="hour" /></Button>;
    $[1] = data_4h_sample;
    $[2] = ghost;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: 382
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      b: 2
    };
    t5 = <Text size="s" semi={true}>Attempts</Text>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Div flex={true} m={t4}>{t5}<Text size="s" semi={true} muted={true} m={{
        x: 1
      }}>{" \xB7 "}</Text><Text size="s" semi={true} neutral={true}>Last 24h</Text></Div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== data_2h_sample) {
    t7 = <StyledCardSection p={4} w={t3}>{t6}<PreviewHistogram values={data_2h_sample} resolution="hour" dimensions_config={dimensions_config} show_tooltip={true} size="medium" /></StyledCardSection>;
    $[8] = data_2h_sample;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      x: 4,
      y: 3
    };
    t9 = {
      justify: "flex-end"
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  const t10 = `/events?destination_id[0]=${destination.id}`;
  let t11;
  if ($[12] !== t10) {
    t11 = <StyledCardSection p={t8} flex={t9}><Button outline={true} to={t10} icon="link">View all attempts</Button></StyledCardSection>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t2 || $[16] !== t7) {
    t12 = <Div w={t1} onClick={_temp}><Dropdown placement="bottom-end" portal={true} renderToggle={t2}>{t7}{t11}</Dropdown></Div>;
    $[14] = t11;
    $[15] = t2;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
export default DestinationMetricsPreview;
function _temp(e) {
  return e.stopPropagation();
}